import React, {useEffect} from 'react';
import {Button, Divider, Image, Layout, Popconfirm, Space, Spin, Typography} from "antd";
import {useNavigate} from "react-router-dom";

import dog_img from "../Resources/dog_example_1.png";
import snapshot from "../Resources/snapshot.png";
import share from "../Resources/share.png"
import {useTheme} from "../ThemeSwitching/use-theme";

import logo from "../Resources/logo.png";
import productGif from "../Resources/7.gif";
import Gradient from "rgt";
import {track} from "@amplitude/analytics-browser";

import {useMediaQuery} from "react-responsive";

const { Header } = Layout;
const { Title } = Typography;
const { Text, Link } = Typography;

const Landing = () => {
    const navigate = useNavigate();

    const isDesktop = useMediaQuery({
        query: "(min-width: 1456px)"
    });

    const isTablet = useMediaQuery({
        query: "(max-width: 1224px)"
    });

    const isMobile = useMediaQuery({
        query: "(max-width: 786px)"
    });

    const isPortrait = useMediaQuery({
        query: "(orientation: portrait)"
    });

    const isRetina = useMediaQuery({
        query: "(max-resolution: 300dpi)"
    });

    const [darkMode, setDarkMode] = useTheme();

    useEffect(() =>{
        track("landing_shown");
    }, []);

    return (
        <div>
            <Header className="header">
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    <Space direction="horizontal" size="small">
                        <Image src={logo} preview={false} style={{width: 64, height: 64}}/>
                        <Title
                            level={3}
                            style={{color: "white", marginTop: 12}}
                        >
                            Dimensions
                        </Title>
                    </Space>


                    <div style={{display: "flex", justifyContent: "space-between"}}>
                        <Button
                            style={{marginTop: 16, marginLeft: 16, width: 128, borderRadius: 8}}
                            type="primary"
                            onClick={() => {
                                track("landing_signin_clicked");
                                navigate("/closed-beta");
                            }}
                        >
                            Sign In
                        </Button>
                    </div>

                </div>
            </Header>

            {/*<div style={{marginTop: 64, marginBottom: isDesktop ? 64 : 32}}>*/}
            {/*    <img src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=349795&theme=light&period=daily"/>*/}
            {/*</div>*/}

            <div style={{display: "flex", flexDirection: "column", justifyContent: "space-around", gap: isDesktop ? 192 : 96, paddingBottom: 192, paddingTop: isDesktop ? 192 : 64}}>
                <div style={{display: "block"}}>
                    <div style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        alignItems: "center",
                        marginLeft: 64,
                        marginRight: 64,
                        flexWrap: "wrap"
                    }}>


                        <div style={{maxWidth: isDesktop ? 528 : 480, textAlign: isDesktop ? "left" : "center", marginBottom: 48}}>
                            <Text style={{fontSize: isMobile ? 32 : 48, fontWeight: "bold"}}>
                                Focus on
                                <Gradient dir="left-to-right" from="#e62c5a" to="#0fabf6">
                                    {" creativity"}
                                </Gradient>,
                                <br/> not on endless routine and iterations
                            </Text>
                            <div style={{marginTop: 24}}>
                                <Text style={{fontSize: isMobile ? 18 : 24}}>
                                    Save your time with Dimensions. Turn rough sketches into high-detailed concepts in a few clicks.
                                </Text>
                            </div>

                            <Button
                                style={{marginTop: 32, width: 256, height: 54}}
                                type="primary"
                                shape="round"
                                onClick={() => {
                                    track("landing_trynow_clicked");
                                    navigate("/closed-beta");
                                }}
                            >
                        <span style={{fontSize: 18, fontWeight: "bold"}}>
                            👀 Try now
                        </span>
                            </Button>

                        </div>

                        <div style={{minWidth: 360}}>
                            <Image src={productGif} preview={false}/>
                        </div>

                    </div>
                </div>

            <div style={{display: "block"}}>
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    alignContent: "center",
                    marginLeft: 64,
                    marginRight: 64,
                    flexWrap: "wrap-reverse"
                }}>

                    <div style={{minWidth: 360}}>
                        <Image src={dog_img} style={{maxWidth: 640}} preview={false}/>
                    </div>

                    <div style={{maxWidth: isDesktop ? 800 : 480, textAlign: isDesktop ? "right" : "center", marginBottom: 48}}>
                        <Text style={{fontSize: isMobile ? 32 : 48, fontWeight: "bold"}}>
                            Never spend hours polishing concepts
                            <Gradient dir="left-to-right" from="#e62c5a" to="#0fabf6">
                                {" again"}
                            </Gradient>
                        </Text>
                        <div style={{marginTop: 24}}>
                            <Text style={{fontSize: isMobile ? 18 : 24}}>
                                Let AI do this for you.
                                <br/><br/>
                                Just describe the desired result using the prompt field.
                                <br/><br/>
                                Enhance the quality of your prompt with one of the predefined styles.
                                <br/><br/>
                                Read the <Link href="prompt-guide" target="_blank"> guide about prompt engineering. </Link>
                            </Text>
                        </div>

                        <Button
                            style={{marginTop: 32, width: 256, height: 54}}
                            type="primary"
                            shape="round"
                            onClick={() => {
                                track("landing_trynow_clicked");
                                navigate("/closed-beta");
                            }}
                        >
                        <span style={{fontSize: 18, fontWeight: "bold"}}>
                            Start creating
                        </span>
                        </Button>

                    </div>
                </div>

            </div>
            </div>



        </div>
    );
};

export default Landing;